import {submitFormData, submitJsonData, submitMultipartFormData} from "../../redare/utils/Request";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

/**
 * @param body: {userId}
 * @param query: {}
 * @returns Promise
 */
export function findMenuRolePermissionByUserId(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/menuRolePermission/findByUserId',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {userId}
 * @param query: {}
 * @returns Promise
 */
export function findMenuRolePermissionByUserIdForApp(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/menuRolePermission/findByUserIdForApp',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

